<template>
  <div class="tt-header">
    <div class="tt-header-left">
      <span class="tt-header-icon"><i :class="['bi', icon]"></i></span>
      <div>
        <h4 class="tt-title">{{ title }}</h4>
        <p v-if="subtitle" class="tt-subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div v-if="$slots.actions" class="tt-header-actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TripPageHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, required: true },
  },
};
</script>
